import { render, staticRenderFns } from "./PageColorPickerModal.vue?vue&type=template&id=4bb9b288&scoped=true&"
import script from "./PageColorPickerModal.vue?vue&type=script&lang=js&"
export * from "./PageColorPickerModal.vue?vue&type=script&lang=js&"
import style0 from "./PageColorPickerModal.vue?vue&type=style&index=0&id=4bb9b288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9b288",
  null
  
)

export default component.exports